// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 322) return "static/chunks/322-1f3391db3bb48981.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 983 ? "80d4461e" : chunkId) + "." + {"29":"604fad4d4dc068fb","182":"eb15643fc60a19dc","237":"1c515f6cc42d5782","352":"5235fa6f9544bef5","427":"139a4c7676461de9","496":"834a44efd1337a6b","834":"d5b27db7c8c153f9","875":"a6f0e078f25f61bd","885":"ca778fb90196fffc","971":"37973cfadd0f549d","983":"7e090af7ce5aa8b1"}[chunkId] + ".js";
};